export default {
    slug: 'emails',
    settingsRoutes: [
        {
            path: 'email-domain',
            name: 'settings-email-domain',
            component: () => import('@modules/Emails/Resources/js/pages/settings/EmailDomain.vue'),
            props: true
        },
        {
            path: 'email-templates',
            name: 'settings-email-template-list',
            component: () => import('@modules/Emails/Resources/js/pages/settings/email-templates/List.vue'),
            children: [
                {
                    path: ':id(\\d+)',
                    name: 'settings-email-template-preview',
                    component: () => import('@modules/Emails/Resources/js/pages/settings/email-templates/Preview.vue'),
                    props: true
                }
            ]
        },
        {
            path: 'email-layout',
            name: 'settings-email-layout',
            component: () => import('@modules/Emails/Resources/js/pages/settings/EmailLayout.vue'),
            props: true
        }
    ],
    settings: () => [
        {
            title: i18n.t('Emails'),
            order: 15,
            items: [
                { title: i18n.t('Email Domain'), icon: 'email-check', route: 'settings-email-domain', admin: true },
                {
                    title: i18n.t('Email Templates'),
                    icon: 'file-document',
                    route: 'settings-email-template-list',
                    permission: 'email-templates'
                },
                {
                    title: i18n.t('Email Layout'),
                    icon: 'palette-outline',
                    route: 'settings-email-layout',
                    permission: 'email-layout'
                }
            ]
        }
    ]
};
